export default "/assets/images/mila-filter-video-3.2ec8a24d27bd4caf.mp4";